$(function () {
    $(".share-facebook").click(function () {
        let url = $(this).data("url");
        FB.ui({
            method: 'share',
            href: url,
            xfbml : false
        }, function (response) { });
    });
});